import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { LanguageService } from 'lib-trend-core';
import { Constants } from '../../../../environments/constantes';

export const MOBILE_APP_MODAL_TITLE_ID = 'mobile-app-modal-title';

/** Shared dialog config, so every entry point (sidebar promo, header menu) opens the picker the same way. */
export const MOBILE_APP_MODAL_CONFIG: MatDialogConfig = {
  width: '560px',
  maxWidth: '95vw',
  ariaLabelledBy: MOBILE_APP_MODAL_TITLE_ID,
};

const STORE_BADGES_PATH = 'assets/images/v2/store-badges';

/** Extension of the Google Play badges downloaded from Google's Partner Marketing Hub. */
const GOOGLE_PLAY_BADGE_EXTENSION = 'png';

interface AppStoreOption {
  id: 'app-store' | 'google-play';
  url: string;
  devicesKey: string;
  qrKey: string;
  badgeAltKey: string;
  badgeSrc: string;
}

/**
 * Device picker for the Trendmulti native app: one card per store with a QR code
 * (hidden on small screens) and the official, localized store badge.
 */
@Component({
  selector: 'mobile-app-modal',
  templateUrl: './mobile-app-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MobileAppModalComponent {

  readonly titleId = MOBILE_APP_MODAL_TITLE_ID;

  /** Typed literals for the <qrcode> union inputs (strictTemplates). */
  readonly qrErrorLevel = 'M' as const;
  readonly qrElementType = 'svg' as const;

  /** Apple's badge guidelines: when several store badges are shown, the App Store badge comes first. */
  readonly stores: AppStoreOption[];

  constructor(
    private readonly dialogRef: MatDialogRef<MobileAppModalComponent>,
    languageService: LanguageService,
  ) {
    // Badges must match the UI language, which cannot change while the modal is open.
    const locale = languageService.currentLang;
    this.stores = [
      {
        id: 'app-store',
        url: Constants.appStoreUrl,
        devicesKey: 'layout.mobileAppModal.appleDevices',
        qrKey: 'layout.mobileAppModal.qrAppStore',
        badgeAltKey: 'layout.mobileAppModal.appStoreBadgeAlt',
        badgeSrc: `${STORE_BADGES_PATH}/app-store.${locale}.svg`,
      },
      {
        id: 'google-play',
        url: Constants.googlePlayUrl,
        devicesKey: 'layout.mobileAppModal.androidDevices',
        qrKey: 'layout.mobileAppModal.qrGooglePlay',
        badgeAltKey: 'layout.mobileAppModal.googlePlayBadgeAlt',
        badgeSrc: `${STORE_BADGES_PATH}/google-play.${locale}.${GOOGLE_PLAY_BADGE_EXTENSION}`,
      },
    ];
  }

  close(): void {
    this.dialogRef.close();
  }

}
